import React from 'react'
import './SueAlertPopUp.css'

interface Props {
    onApprove?: Function;
    onClose?: Function;
    onCancel?: Function;

}

const SueAlertPopUp = (props: Props) => {

    const onApprove = () => {
        if(props.onApprove){
            props.onApprove();
        }
    }

    const onClose = () => {
        if(props.onClose){
            props.onClose();
        }
    }

    const onCloseAlertAndCancel = () => {
        if(props.onCancel){
            props.onCancel();
        }
    }

    return (
        <div className="popup-wrapper-warning">
            <div className='header-warning'>
                <div>
                    <div className='title-warning'></div>
                </div>
                <button className='close-icon-warning' onClick={onCloseAlertAndCancel}>x</button>
            </div>

            <div className='content-warning'>
                <div className='message-warning'>האם ברצונך לשמור את השינויים שביצעת בתביעה?</div>
                <div className='buttons-warning'>
                    <button className='popup-button-warning approve' onClick={onApprove}>שמור</button>
                    <button className='popup-button-warning cancel' onClick={onClose}>סגור</button>
                </div>
                
            </div>
            
        </div>
    )
}

export default SueAlertPopUp